import { useLang } from "@/i18n/LanguageContext";

export const Marquee = () => {
  const { t } = useLang();
  const row = [...t.marquee, ...t.marquee];
  return (
    <div className="relative border-y border-white/10 bg-white/[0.02] py-7 overflow-hidden" data-testid="editorial-marquee">
      <div className="marquee-track flex w-max">
        {[0, 1].map((k) => (
          <div key={k} className="flex shrink-0 items-center" aria-hidden={k === 1}>
            {row.map((w, i) => (
              <span key={`${k}-${i}`} className="flex items-center font-display text-3xl md:text-5xl font-bold tracking-tight whitespace-nowrap">
                <span className={i % 2 ? "text-outline" : "text-white"}>{w}</span>
                <span className="mx-8 md:mx-12 text-[#f43f5e] text-2xl">✦</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
